import React, {FC} from 'react'
import classNames from 'classnames'
import {Row, Col} from 'antd'
import StylesType from '@/types/StylesType'
import {Product} from '@/types/BuyTypes'

import './style/Product.less'

interface ProcductType {
  product: Product;
  groupId: number;
  changeGroupId:(id: number)=>void
}

export type ProcductProps = StylesType & ProcductType

const Procduct: FC<ProcductProps> = props => {
  const {className, prefixCls = 'gc_', product, groupId, changeGroupId} = props
  return (
    <>
      <Row
        type='flex'
        align='middle' gutter={[0, 0]} className={classNames(prefixCls + 'product', className, {actived: groupId === product.id})}
        onClick={() =>changeGroupId(product.id)}
      >
        <Col><img src={product.picUrl} alt=''/></Col>
        <Col>
          <Row className={classNames('product_desc')}>
            <Col className={classNames('title')}>{product.productName}</Col>
            <Col><pre>{product.productDesc}</pre></Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}
export default Procduct
